export const BUSINESS_CUSTOMER = 1;
export const VERWALTUNG = 2;
export const RELATED_COMPANY = 3;

export default Object.freeze({
  BUSINESS_CUSTOMER,
  VERWALTUNG,
  RELATED_COMPANY
});
